import React from "react";

import { Grid, Paper } from "@material-ui/core";

import "./FormProgress.scss";

interface Props {
  maxStep: number;
  step: number;
  onClick: (step: number) => void;
}

export const FormProgress = ({ maxStep, step, onClick }: Props): any => {
  const inactive = "progress-dot";
  const active = "progress-dot--active";

  return (
    <Grid
      container
      justify="center"
      style={{
        marginTop: 75,
        marginBottom: 50,
      }}
    >
      {Array.from(Array(maxStep)).map((_, i) => {
        return (
          <Grid item className="progress-dot-container" key={i}>
            <Paper>
              <button
                disabled={i > step}
                className={step === i ? active : inactive}
                onClick={(e) => {
                  onClick(i);
                }}
              />
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};
